//TODO: naming for variable
import { colors } from '@atlaskit/theme';

export default {
  palette: {
    primary: '#0A7EF9',
    secondary: '#1084fe',
    emerald: '#52D769',
    success: '#3BCE7F',
    danger: '#FB5151',
    rollingStone: '#787D83',
    warning: '#F9BE02',
    error: '#FB5151',
    info: '#2a2f45',
    white: '#ffffff',
    black: '#000000',
    wildWatermelon: '#FF646F',
    fiord: '#42526E',
    carnage: '#f86c6b',
    selago: '#fafafe',
    iceberg: '#D4F1E5',
    iron: '#E2E3E4',
    blueCharcoal: '#000A19',
    blueLink: '#0071b2',
    lightBlue: '#edf0f7',
    frenchPass: '#CEE5FE',
    catskillWhite: '#EDF0F7',
    athensGrey: '#f6f6f7',
    riverBed: '#454d5b',
    manatee: '#9A9DA3',
    bombay: '#ACB0B8',
    frenchGrey: '#C7C9CE',
    zircon: '#f6f9ff',
    slateGrey: '#7a8392',
    bonJour: '#E3DFDF',
    dustyGray: '#999999',
    denim: '#1565c0',
    doveGray: '#616161',
    alabaster: '#f9f9f9',
    geyser: '#dae1e5',
    shuttleGrey: '#596171',
    chablis: '#FFEFEF',
    trout: '#4e5766',
    darkBlue: '#0E2F47',
    guardsmanRed: '#c62828',
    blue: {
      one: '#CEE5FE',
    },
    grey: {
      one: '#d6dde1',
      two: '#D3D3D3',
      three: '#A9A9A9',
      four: '#808080',
      five: 'grey',
      six: '#FAFBFC',
      seven: '#F2F2F2',
      eight: '#6D7278',
      nine: '#636D7C',
      ten: '#F4F4F4',
    },
    yellow: {
      one: '#FAD273',
    },
    text: {
      primary: '#394f5a',
      secondary: '#353B47',
      tertiary: '#092645',
      dark: '#353f45',
      light: '#5e6c84',
      one: '#2F3C4E',
      two: '#353B47',
      three: '#495465',
      danger: '#FB5151',
      input: '#454d5b',
    },
    action: {
      hover: '#e5f1ff',
    },
    tooltip: {
      background: 'rgba(0, 0, 0, 0.9)',
    },
    border: {
      one: '#b5d2e1',
      two: '#d6dde1',
      three: '#9eabb2',
      four: '#00000010',
      five: '#00000030',
      six: '#6D727833',
      seven: '#FA6400',
      eight: '#f9fafd',
      nine: '#6d7278',
      ten: '#6d72784d',
    },
    gray: '	#808080',
    silver: '#bdbdbd',
    lightGray: '#D3D3D3',
    brightGrey: '#3c4351',
    azureRadiance: '#0889fa',
    darkGray: '#A9A9A9',
    icon: {
      active: '#0A7EF9',
      inactive: '#d6dde1',
    },
    insentBlue: '#0a7ef9',
    nav: {
      background: colors.DN0,
      text: colors.N0,
      hover: 'rgba(10,126,249,0.2)',
    },
  },
  border: '#b5d2e1',
  colors: {
    primary: '#556cd6',
    white: '#fff',
    black: '#000',
    borderColor: '#d6dde1',
    hover: '#e5f1ff',
    textPrimary: '#394f5a',
    textSecondary: '#353f45',
    textTertiary: '#7695a5',
    darkText: '#353f45',
    link: '#7CB5EC',
    ratingGreen: '#91CF50',
    ratingBlue: '#54B4F9',
  },
  boxShadow: {
    card: '0px 5px 20px rgba(0, 0, 0, 0.05)',
    topShadowPopupEffect: 'rgba(14,30,62,0.2) 2px -2px 8px -2px',
    bottomShadowPopupEffect: 'rgba(14, 30, 62, 0.2) 0px 2px 2px 0px',
    cardLightShadow: '0px 2px 20px rgba(53, 59, 71, 0.08)',
    popupLightShadow: '0px -3px 12px 0 rgba(53, 59, 71, 0.07)',
    popupLightBefore: '-4px 2px 2px 0 rgba(53, 59, 71, 0.02)',
    popupDarkBefore: '-2px 2px 5px 0 rgba(53, 59, 71, 0.1)',
    cardLighterShadow: '0px 5px 10px rgba(0, 0, 0, 0.02)',
    selectDropdownShadow: '0px 2px 20px rgba(53, 59, 71, 0.08)',
  },
  conversationPage: {
    background: '#FCFCFE',
    grid: {
      background: '#ffffff',
      border: '#edf0f7',
    },
  },
};
